module.exports = __webpack_public_path__ + "img/pcard.4a776917.png";